<template>
  <div class="flex items-center gap-4">
    <div
      class="h-[28px] flex items-center gap-[2px] pl-[6px] pr-[10px] bg-cbg02 border border-solid border-[#f0f0f0] rounded cursor-pointer"
      @click="handleBack"
    >
      <img src="@/assets/page-back-arrow.png" class="w-[16px]">
      <div class="text-sm text-ctext01">返回</div>
    </div>
    <div class="text-base text-ctext01 font-bold">{{ title }}</div>
  </div>
</template>
<script>

export default {
  name: 'PageBackHeader',
  props: {
    title: {
      type: String,
      default: ''
    }
  },
  methods: {
    handleBack() {
      this.$router.back();
    }
  }
};
</script>
